module.exports = __webpack_public_path__ + "img/dfa.7d587033.jpg";